import { useState } from "react";
import DateTimePicker from 'react-datetime-picker';
import NumberFormat from 'react-number-format';
import { toast, ToastContainer } from 'react-toastify';
import { reactLocalStorage } from 'reactjs-localstorage';
import { LoaderSpinner } from "../../atoms";
import { useNavigate } from "react-router-dom";


const StepTwo = () => {
  const [desc, setDesc] = useState('')
  const [tokenPresale, setTokenPresale] = useState('')
  const [tokenLiquidity, setTokenLiquidity] = useState('')
  const [type, setType] = useState('')
  const [listingOn, setListingOn] = useState('')
  const [presaleRate, setPresaleRate] = useState('')
  const [listingPresale, setListingPresale] = useState('')
  const [hardCap, setHardCap] = useState('')
  const [softCap, setSoftCap] = useState('')
  const [liquidity, setLiquidity] = useState('')
  const [minCont, setMinCont] = useState('')
  const [maxCont, setMaxCont] = useState('')
  const [startTime, setStartTime] = useState(new Date())
  const [endTime, setEndTime] = useState(new Date())
  const [liqLockTime, setLiqLockTime] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const handleNext = () => {
    if (desc && tokenPresale && tokenLiquidity && presaleRate && listingPresale && hardCap && softCap && liquidity && minCont && maxCont && liqLockTime
    ) {
      setIsLoading(true)
      let formOne = reactLocalStorage.getObject('formData')
      reactLocalStorage.setObject('formData', {
        desc,
        tokenPresale,
        tokenLiquidity,
        tokenType:type,
        listingOn,
        listingRate:presaleRate,
        listingPresale,
        hardCap,
        softCap,
        liquidity,
        minContribute:minCont,
        maxContribute:maxCont,
        startTime,
        endTime,
        liquidityLockupTime:liqLockTime,
        ...formOne
      })
      navigate('/create?step=3')
      setIsLoading(false)
    } else {
      toast.error("Please complete requred field!")
    }
  }
  return (
    <>
      <div className="step-info">
        <h3 className="step-title">Launchpad Info</h3>
        <span className="desc">
          Please provide information as detail and concise as possible
        </span>
      </div>
      <div className="form-step">
        <div className="input-wrapper desc">
          <span className="isRequired">*</span>
          <textarea className="input-token" rows="10" placeholder="Description" value={desc} onChange={(e) => setDesc(e.target.value)}></textarea>
        </div>
        <div className="input-wrapper">
          <span className="isRequired">*</span>
          <NumberFormat
            value={tokenPresale}
            onChange={(e) => setTokenPresale(e.target.value)}
            thousandSeparator={true}
            placeholder="Token For Presale"
            className="input-token"
          />
        </div>
        <div className="input-wrapper">
          <span className="isRequired">*</span>
          <NumberFormat
            value={tokenLiquidity}
            onChange={(e) => setTokenLiquidity(e.target.value)}
            thousandSeparator={true}
            placeholder="Token For Liquidity"
            className="input-token"
          />
        </div>

        <div className="row">
          <div className="col-lg">
            <div className="input-wrapper">
              <span className="isRequired">*</span>
              <select style={{ cursor: 'pointer' }} className="select-token" value={type} onChange={(e) => setType(e.target.value)}>
                <option>Listing Type</option>
                <option value="public">PUBLIC</option>
                <option value="private">PRIVATE</option>
              </select>
            </div>
          </div>
          {
            type === 'public' && (
              <div className="col-lg">
                <div className="input-wrapper">
                  <span className="isRequired">*</span>
                  <select style={{ cursor: 'pointer' }} className="select-token" value={listingOn} onChange={(e) => setListingOn(e.target.value)}>
                    <option>Listing On</option>
                    <option value="PancakeSwap">PancakeSwap</option>
                  </select>
                </div>
              </div>
            )
          }
        </div>





        <div className="row">
          <div className="col-lg-6">
            <div className="input-wrapper">
              <span className="isRequired">*</span>
              <NumberFormat
                value={presaleRate}
                onChange={(e) => setPresaleRate(e.target.value)}
                thousandSeparator={true}
                placeholder="Presale Rate [per BNB]"
                className="input-token"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="input-wrapper">
              <span className="isRequired">*</span>
              <NumberFormat
                value={listingPresale}
                onChange={(e) => setListingPresale(e.target.value)}
                thousandSeparator={true}
                placeholder="Listing Rate [per BNB]"
                className="input-token"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="input-wrapper">
              <span className="isRequired">*</span>
              <NumberFormat
                value={softCap}
                onChange={(e) => setSoftCap(e.target.value)}
                thousandSeparator={true}
                placeholder="Soft Cap [BNB]"
                className="input-token"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="input-wrapper">
              <span className="isRequired">*</span>
              <NumberFormat
                value={hardCap}
                onChange={(e) => setHardCap(e.target.value)}
                thousandSeparator={true}
                placeholder="Hard Cap [BNB]"
                className="input-token"
              />
            </div>
          </div>
        </div>
        <div className="input-wrapper">
          <span className="isRequired">*</span>
          <NumberFormat
            value={liquidity}
            onChange={(e) => setLiquidity(e.target.value)}
            thousandSeparator={true}
            placeholder="Liquidity [%]"
            className="input-token"
          />
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="input-wrapper">
              <span className="isRequired">*</span>
              <input value={minCont} onChange={(e) => setMinCont(e.target.value)} type="text" className="input-token" placeholder="Min. Contribution [BNB]" />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="input-wrapper">
              <span className="isRequired">*</span>
              <input value={maxCont} onChange={(e) => setMaxCont(e.target.value)} type="text" className="input-token" placeholder="Max. Contribution [BNB]" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="input-wrapper">
              <span className="isRequired">*</span>
              <small className="topLabel">Start Time</small>
              <DateTimePicker
                className="input-token"
                onChange={setStartTime}
                value={startTime}
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="input-wrapper">
              <span className="isRequired">*</span>
              <small className="topLabel">End Time</small>
              <DateTimePicker
                className="input-token"
                onChange={setEndTime}
                value={endTime}
              />
            </div>
          </div>
        </div>
        <div className="input-wrapper">
          <span className="isRequired">*</span>
          <input value={liqLockTime} onChange={(e) => setLiqLockTime(e.target.value)} type="number" className="input-token" placeholder="Liquidity Lockup Time [days]" />
        </div>
      </div>
      <div className="action-next">
        {/* <Link onClick={handleNext} className="next-link" to="/create?step=3">NEXT</Link> */}
        <button onClick={handleNext} className="next-link">NEXT</button>
      </div>
      {
        isLoading && <LoaderSpinner />
      }
      <ToastContainer position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
    </>
  )
}

export default StepTwo
